module.exports = __webpack_public_path__ + "img/20_dice[14].147439e6.png";